module.exports = __webpack_public_path__ + "static/media/Biddenden-Heart-WHite NEW 2.636694d6.avif";